import { useEffect } from "react";

export function useEscKey(fn: () => void, enabled: boolean) {
    useEffect(() => {
        if (!enabled) return;
        const handler = (e: KeyboardEvent) => { if (e.key === "Escape") fn(); };
        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, [enabled, fn]);
}
